import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { EventsService } from './events.service';
import { Observable } from 'rxjs/internal/Observable';
import { RepairAppointment } from '@app/shared/models/RepairAppointment.model';
import { BehaviorSubject, Subject, Subscription, takeUntil } from 'rxjs';
import { ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';

@Component({
    selector: 'app-events-feature',
    templateUrl: './events-feature.component.html',
    imports: [ CommonModule ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventsFeatureComponent implements OnInit, OnDestroy {
    repairAppointments: RepairAppointment[] | null = null;

    config = {
        defaultMinEvents: 3,
        defaultMaxEvents: 99,
        limitVisibleEvents: true,
        eventsToShow: 3
    }

    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;
    // loading = true;
    // noEventsFound = false;
    eventsFound = new BehaviorSubject(false);

    repairAppointments$: Observable<RepairAppointment[]> | null = null;

    constructor(
        private adb2cService: Adb2cService,
        private eventsService: EventsService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.adb2cService.getUser();
        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.repairAppointments$ = this.eventsService.getRepairAppointments(user.sub, user[ 'tenancy_reference' ]!).pipe(takeUntil(this.destroy$));
                this.repairAppointments$.subscribe({
                    next: (r: RepairAppointment[]) => {
                        console.log(r);
                        this.repairAppointments = r?.slice(0, this.config.defaultMaxEvents);

                        // hide spinner

                        if (this.repairAppointments && this.repairAppointments.length > 0) {
                            this.eventsFound.next(true);
                        }
                    },
                    error: (e) => {
                        throw e;
                    }
                })
            }
        });
    }

    showMoreActivities() {
        this.config.limitVisibleEvents = !this.config.limitVisibleEvents;
        if (this.config.limitVisibleEvents) {
            this.config.eventsToShow = this.config.defaultMinEvents;
        } else {
            this.config.eventsToShow = this.config.defaultMaxEvents;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }
}
